module.exports = __webpack_public_path__ + "img/viewInfo_ewm.5bf427c9.png";